import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-content" }
const _hoisted_3 = {
  class: "trezo-tabs",
  id: "trezo-tabs"
}
const _hoisted_4 = { class: "navs mb-[20px] border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_5 = { class: "nav-item inline-block ltr:mr-[20px] rtl:ml-[20px]" }
const _hoisted_6 = { class: "nav-item inline-block ltr:mr-[20px] rtl:ml-[20px]" }
const _hoisted_7 = { class: "nav-item inline-block ltr:mr-[20px] rtl:ml-[20px]" }
const _hoisted_8 = { class: "tab-content" }
const _hoisted_9 = { class: "tab-pane" }
const _hoisted_10 = { class: "tab-pane" }
const _hoisted_11 = { class: "tab-pane" }
const _hoisted_12 = { class: "relative click-to-show-hide-code" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between" }, [
      _createElementVNode("div", { class: "trezo-card-title" }, [
        _createElementVNode("h5", { class: "mb-0" }, "Basic Tabs")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass([
                'nav-link block pb-[8px] transition-all relative font-medium',
                { active: _ctx.activeTab === 'tab1' },
              ]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setActiveTab('tab1')))
            }, " Tab 1 ", 2)
          ]),
          _createElementVNode("li", _hoisted_6, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass([
                'nav-link block pb-[8px] transition-all relative font-medium',
                { active: _ctx.activeTab === 'tab2' },
              ]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setActiveTab('tab2')))
            }, " Tab 2 ", 2)
          ]),
          _createElementVNode("li", _hoisted_7, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass([
                'nav-link block pb-[8px] transition-all relative font-medium',
                { active: _ctx.activeTab === 'tab3' },
              ]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setActiveTab('tab3')))
            }, " Tab 3 ", 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("div", _hoisted_9, _cache[5] || (_cache[5] = [
            _createElementVNode("p", null, "Tab 1 - Hello World!", -1)
          ]), 512), [
            [_vShow, _ctx.activeTab === 'tab1']
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_10, _cache[6] || (_cache[6] = [
            _createElementVNode("p", null, "Tab 2 - Hello World!", -1)
          ]), 512), [
            [_vShow, _ctx.activeTab === 'tab2']
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_11, _cache[7] || (_cache[7] = [
            _createElementVNode("p", null, "Tab 3 - Hello World!", -1)
          ]), 512), [
            [_vShow, _ctx.activeTab === 'tab3']
          ])
        ])
      ]),
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "mt-[15px] md:mt-[20px]" }, null, -1)),
      _createElementVNode("button", {
        type: "button",
        class: "clickToSeeCodeBtn inline-block text-black dark:text-white font-semibold",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleCode && _ctx.toggleCode(...args)))
      }, _toDisplayString(_ctx.showCode ? "Click to Hide Code:" : "Click to See Code:"), 1),
      _withDirectives(_createElementVNode("div", _hoisted_12, [
        _createElementVNode("button", {
          class: "absolute text-lg ltr:right-[20px] rtl:left-[20px] top-[20px] transition-all text-primary-500 copy-btn w-[35px] h-[35px] inline-block border border-primary-500 bg-white rounded-sm dark:bg-[#0c1427]",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.copyCode && _ctx.copyCode(...args))),
          type: "button"
        }, _cache[8] || (_cache[8] = [
          _createElementVNode("i", { class: "ri-file-copy-line" }, null, -1)
        ])),
        _cache[9] || (_cache[9] = _createElementVNode("pre", { class: "line-numbers !mt-[15px] !py-0 !px-[20px] md:!px-[25px] mb-0" }, [
          _createTextVNode(""),
          _createElementVNode("code", {
            class: "language-markup",
            id: "copyCodes"
          }, "\n  <template>\n  <div class=\"trezo-tabs\" id=\"trezo-tabs\">\n    <ul\n      class=\"navs mb-[20px] border-b border-gray-100 dark:border-[#172036]\"\n    >\n      <li class=\"nav-item inline-block ltr:mr-[20px] rtl:ml-[20px]\">\n        <button\n          type=\"button\"\n          :class=\"[\n            'nav-link block pb-[8px] transition-all relative font-medium',\n            { active: activeTab === 'tab1' },\n          ]\"\n          @click=\"setActiveTab('tab1')\"\n        >\n          Tab 1\n        </button>\n      </li>\n      <li class=\"nav-item inline-block ltr:mr-[20px] rtl:ml-[20px]\">\n        <button\n          type=\"button\"\n          :class=\"[\n            'nav-link block pb-[8px] transition-all relative font-medium',\n            { active: activeTab === 'tab2' },\n          ]\"\n          @click=\"setActiveTab('tab2')\"\n        >\n          Tab 2\n        </button>\n      </li>\n      <li class=\"nav-item inline-block ltr:mr-[20px] rtl:ml-[20px]\">\n        <button\n          type=\"button\"\n          :class=\"[\n            'nav-link block pb-[8px] transition-all relative font-medium',\n            { active: activeTab === 'tab3' },\n          ]\"\n          @click=\"setActiveTab('tab3')\"\n        >\n          Tab 3\n        </button>\n      </li>\n    </ul>\n    <div class=\"tab-content\">\n      <div class=\"tab-pane\" v-show=\"activeTab === 'tab1'\">\n        <p>Tab 1 - Hello World!</p>\n      </div>\n      <div class=\"tab-pane\" v-show=\"activeTab === 'tab2'\">\n        <p>Tab 2 - Hello World!</p>\n      </div>\n      <div class=\"tab-pane\" v-show=\"activeTab === 'tab3'\">\n        <p>Tab 3 - Hello World!</p>\n      </div>\n    </div>\n  </div>\n</template>\n\n<script lang=\"ts\">\nimport { defineComponent, ref } from \"vue\";\n\nexport default defineComponent({\nname: \"BasicTabs\",\nsetup() {\nconst activeTab = ref(\"tab1\");\n\nconst setActiveTab = (tab: string) => {\n  activeTab.value = tab;\n};\n\nreturn {\n  activeTab,\n  setActiveTab,\n};\n},\n});\n</script>\n"),
          _createTextVNode("\n")
        ], -1))
      ], 512), [
        [_vShow, _ctx.showCode]
      ])
    ])
  ]))
}